<br />
<div>
  <mat-tab-group (selectedTabChange)="tabChange($event)">
    <!-- <mat-tab-group [selectedIndex]="getActiveIndex() | async"> -->
    <ng-container *ngFor="let mortgage of mortgageArray; let i = index">
      <mat-tab (click)="activeMortgageValue(mortgage)">
        <ng-template mat-tab-label (click)="activeMortgageValue(mortgage)">Mortgage {{ i + 1 }} </ng-template>
        <div *ngIf="mortgage" style="overflow-x: hidden">
          <app-refinance-mortgage [mortgage]="mortgage"> </app-refinance-mortgage>
        </div>
        <!-- <div mat-dialog-content *ngIf="activeTabIndex == i">
        <app-property-mortgage [mortgageData]="mortgage" class="mx-0"></app-property-mortgage>
      </div> -->
      </mat-tab>
    </ng-container>
    <!-- <ng-container *ngIf="mortgageList.length > 1">
      <mat-tab label="All Mortgage">
        <div class="myH_MGroup" *ngIf="!mortgage" style="overflow-x: hidden">
          <app-refinance-allmortage-scenario [mortgageList]="mortgageArray"></app-refinance-allmortage-scenario>
        </div>
      </mat-tab>
    </ng-container> -->
  </mat-tab-group>
</div>

<!-- <app-refinance-mortgage  *ngIf="activeTabIndex === mortgageList.length"  [mortgage]="mortgage"> </app-refinance-mortgage> -->

<!-- <div class="row mt-3 m-0">
  <div class="table-responsive">
    <table class="w-100 mtable">
      <tr>
        <th><div>&nbsp;</div></th>
        <th>Current Loan</th>
        <th>New Loan Scenario 1</th>
      </tr>
      <tr>
        <td>Total Loan Balance</td>
        <td>$540,804</td>
        <td>1,983,979</td>
      </tr>
      <tr>
        <td>Maximum Term</td>
        <td>30 years</td>
        <td>
          <mat-form-field class="w-30 form-fld">
            <input
              type="number"
              class="text-center pb-0"
              matInput
              name="closeByYears"
              min="0"
              max="100"
              (input)="changeInCurrentLoan($event)"
              [(ngModel)]="closeByYears"
              autocomplete="off"
            />
            <span matSuffix>Year</span>
          </mat-form-field>
          <mat-slider
            class="ml-3"
            thumbLabel
            tickInterval="1"
            step="1"
            min="0"
            max="20"
            aria-label="units"
          ></mat-slider>
        </td>
      </tr>
      <tr>
        <td>Total Interest Paid</td>
        <td>6.41%</td>
        <td>
          <mat-form-field class="w-30 form-fld">
            <input
              type="number"
              class="text-center pb-0"
              matInput
              name="closeByYears"
              min="0"
              max="100"
              autocomplete="off"
            />
          </mat-form-field>
          <mat-slider
            class="ml-3"
            thumbLabel
            tickInterval="1"
            step="1"
            min="0"
            max="20"
            aria-label="units"
          ></mat-slider>
        </td>
      </tr>
      <tr>
        <td>Expected Closing Costs</td>
        <td>&nbsp;</td>
        <td>
          <mat-form-field class="w-30 form-fld">
            <input
              type="number"
              class="text-center pb-0"
              matInput
              name="closeByYears"
              min="0"
              max="100"
              autocomplete="off"
            />
          </mat-form-field>
          <mat-slider
            class="ml-3"
            thumbLabel
            tickInterval="1"
            step="1"
            min="0"
            max="20"
            aria-label="units"
          ></mat-slider>
        </td>
      </tr>
      <tr>
        <td>Total Monthly Payment</td>
        <td><b>$4,907</b></td>
        <td><b>$13,787</b></td>
      </tr>
      <tr>
        <td>Time until Payoff</td>
        <td><b>23 years 9 months</b></td>
        <td><b>15 years</b></td>
      </tr>
      <tr>
        <td>Change in Total Monthly Payment</td>
        <td><b></b></td>
        <td class="val">
          <b>$1,065 <img class="ml-2" src="../../../assets/images/up.svg" width="12" /></b>
        </td>
      </tr>
      <tr>
        <td>Change in Total Monthly Interest</td>
        <td><b></b></td>
        <td class="val">
          <b>$19,265 <img class="ml-2" src="../../../assets/images/up.svg" width="12" /></b>
        </td>
      </tr>
      <tr>
        <td>Time to break even</td>
        <td><b></b></td>
        <td>
          <b>3 months</b>
        </td>
      </tr>
      <tr>
        <td></td>
        <td><button mat-flat-button color="primary">Choose this Scenario</button></td>
        <td><button mat-stroked-button color="primary">Choose this Scenario</button></td>
      </tr>
    </table>
  </div>
</div>

<div class="myH_refinance mt-4 px-1 container">
  <h6>How much you can save by refinancing</h6>
  <mat-card class="myH_refCal mr-4">
    <div class="col-lg-4 col-md-12">
      <p class="label">Current Balance:</p>
      <form [formGroup]="refinanceForm">
        <mat-form-field class="w-75">
          <input class="text-left" matInput currencyMask formControlName="loanBalance" autocomplete="off" />
          <span matPrefix>$&nbsp;</span>
        </mat-form-field>
      </form>
      <span *ngIf="errorInField && errorInField.loanBalance == false" class="errMsg-alert">
        {{ errorMessage }}
      </span>
    </div>
    <div class="col-lg-4 col-md-12">
      <p class="label">Term Balance:</p>
      <mat-form-field class="w-40">
        <input
          type="number"
          class="text-center"
          matInput
          name="closeByYears"
          min="0"
          max="100"
          (input)="changeInCurrentLoan($event)"
          [(ngModel)]="closeByYears"
          autocomplete="off"
        />
        <span matSuffix>Year</span>
      </mat-form-field>
      <span *ngIf="errorInField && errorInField.closeByYears == false" class="errMsg-alert">
        {{ errorMessage }}
      </span>
      <mat-form-field class="w-40 ml-2">
        <input
          type="number"
          class="text-center"
          matInput
          name="closeByMonths"
          min="0"
          max="11"
          (input)="changeInCurrentLoan($event)"
          [(ngModel)]="closeByMonths"
          autocomplete="off"
        />
        <span matSuffix>Mnth</span>
      </mat-form-field>
      <span *ngIf="errorInField && errorInField.closeByMonths == false" class="errMsg-alert">
        {{ errorMessage }}
      </span>
    </div>
    <div class="col-lg-4 col-md-12">
      <p class="label">Current Interest:</p>
      <mat-form-field class="w-50">
        <input
          matInput
          [(ngModel)]="loanInterest"
          min="0"
          max="100"
          name="loanInterest"
          type="number"
          (input)="changeInCurrentLoan($event)"
          autocomplete="off"
        />
        <span matSuffix>%</span>
      </mat-form-field>
      <span *ngIf="errorInField && errorInField.loanInterest == false" class="errMsg-alert">
        {{ errorMessage }}
      </span>
    </div>
  </mat-card>
  <section class="refinance-form mt-4">
    <div class="row">
      <div class="col-12 col-md-3 form-label">Term(Yrs)</div>
      <div class="col-4 col-md-3 text-right pr-xl-5 pr-lg-4 pr-md-3" [ngClass]="activeRefinance == 1 ? 'active' : ''">
        <mat-form-field class="w-25">
          <input
            matInput
            type="number"
            max="100"
            name="term1"
            class="text-center"
            (input)="calculateLoan('term1', $event)"
            [(ngModel)]="term1"
            autocomplete="off"
          />
        </mat-form-field>
        <span *ngIf="errorInField && errorInField.term1 == false" class="errMsg-alert">
          {{ errorMessage }}
        </span>
      </div>
      <div class="col-4 col-md-3 text-right pr-xl-5 pr-lg-4 pr-md-3" [ngClass]="activeRefinance == 2 ? 'active' : ''">
        <mat-form-field class="w-25">
          <input
            matInput
            type="number"
            max="100"
            name="term2"
            class="text-center"
            (input)="calculateLoan('term2', $event)"
            [(ngModel)]="term2"
            autocomplete="off"
          />
        </mat-form-field>
        <span *ngIf="errorInField && errorInField.term2 == false" class="errMsg-alert">
          {{ errorMessage }}
        </span>
      </div>
      <div class="col-4 col-md-3 text-right pr-xl-5 pr-lg-4 pr-md-3" [ngClass]="activeRefinance == 3 ? 'active' : ''">
        <mat-form-field class="w-25">
          <input
            matInput
            type="number"
            max="100"
            name="term3"
            class="text-center"
            (input)="calculateLoan('term3', $event)"
            [(ngModel)]="term3"
            autocomplete="off"
          />
        </mat-form-field>
        <span *ngIf="errorInField && errorInField.term3 == false" class="errMsg-alert">
          {{ errorMessage }}
        </span>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-3 form-label">Interest(%)</div>
      <div class="col-4 col-md-3 text-right pr-xl-5 pr-lg-4 pr-md-3" [ngClass]="activeRefinance == 1 ? 'active' : ''">
        <mat-form-field class="w-25">
          <input
            matInput
            type="number"
            min="0"
            max="100"
            class="text-center"
            name="term1InterestRate"
            (input)="calculateLoan('term1', $event)"
            [(ngModel)]="term1InterestRate"
            autocomplete="off"
          />
        </mat-form-field>
        <span *ngIf="errorInField && errorInField.term1InterestRate == false" class="errMsg-alert">
          {{ errorMessage }}
        </span>
      </div>
      <div class="col-4 col-md-3 text-right pr-xl-5 pr-lg-4 pr-md-3" [ngClass]="activeRefinance == 2 ? 'active' : ''">
        <mat-form-field class="w-25">
          <input
            matInput
            type="number"
            min="0"
            max="100"
            class="text-center"
            name="term2InterestRate"
            (input)="calculateLoan('term2', $event)"
            [(ngModel)]="term2InterestRate"
            autocomplete="off"
          />
        </mat-form-field>
        <span *ngIf="errorInField && errorInField.term2InterestRate == false" class="errMsg-alert">
          {{ errorMessage }}
        </span>
      </div>
      <div class="col-4 col-md-3 text-right pr-xl-5 pr-lg-4 pr-md-3" [ngClass]="activeRefinance == 3 ? 'active' : ''">
        <mat-form-field class="w-25">
          <input
            matInput
            type="number"
            min="0"
            max="100"
            class="text-center"
            name="term3InterestRate"
            (input)="calculateLoan('term3', $event)"
            [(ngModel)]="term3InterestRate"
            autocomplete="off"
          />
        </mat-form-field>
        <span *ngIf="errorInField && errorInField.term3InterestRate == false" class="errMsg-alert">
          {{ errorMessage }}
        </span>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-3 form-label">Monthly payment</div>
      <div class="col-4 col-md-3 text-right pr-xl-5 pr-lg-4 pr-md-3" [ngClass]="activeRefinance == 1 ? 'active' : ''">
        <p>{{ term1MonthlyPayment | currency: 'USD':'symbol':'0.0-0' }}</p>
      </div>
      <div class="col-4 col-md-3 text-right pr-xl-5 pr-lg-4 pr-md-3" [ngClass]="activeRefinance == 2 ? 'active' : ''">
        <p>{{ term2MonthlyPayment | currency: 'USD':'symbol':'0.0-0' }}</p>
      </div>
      <div class="col-4 col-md-3 text-right pr-xl-5 pr-lg-4 pr-md-3" [ngClass]="activeRefinance == 3 ? 'active' : ''">
        <p>{{ term3MonthlyPayment | currency: 'USD':'symbol':'0.0-0' }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-3 form-label">Change in payment</div>
      <div class="col-4 col-md-3 text-right pr-xl-5 pr-lg-4 pr-md-3" [ngClass]="activeRefinance == 1 ? 'active' : ''">
        <p>{{ term1ChangeInPayment | currency: 'USD':'symbol':'0.0-0' }}</p>
      </div>
      <div class="col-4 col-md-3 text-right pr-xl-5 pr-lg-4 pr-md-3" [ngClass]="activeRefinance == 2 ? 'active' : ''">
        <p>{{ term2ChangeInPayment | currency: 'USD':'symbol':'0.0-0' }}</p>
      </div>
      <div class="col-4 col-md-3 text-right pr-xl-5 pr-lg-4 pr-md-3" [ngClass]="activeRefinance == 3 ? 'active' : ''">
        <p>{{ term3ChangeInPayment | currency: 'USD':'symbol':'0.0-0' }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-3 form-label">Total savings</div>
      <div class="col-4 col-md-3 text-right pr-xl-5 pr-lg-4 pr-md-3" [ngClass]="activeRefinance == 1 ? 'active' : ''">
        <p
          [ngClass]="{
            negativeValue: isPositive(term1TotalSavings) == -1,
            positiveValue: isPositive(term1TotalSavings) == 1
          }"
        >
          <strong> {{ term1TotalSavings | currency: 'USD':'symbol':'0.0-0' }} </strong>
        </p>
      </div>
      <div class="col-4 col-md-3 text-right pr-xl-5 pr-lg-4 pr-md-3" [ngClass]="activeRefinance == 2 ? 'active' : ''">
        <p
          [ngClass]="{
            negativeValue: isPositive(term2TotalSavings) == -1,
            positiveValue: isPositive(term2TotalSavings) == 1
          }"
        >
          <strong> {{ term2TotalSavings | currency: 'USD':'symbol':'0.0-0' }} </strong>
        </p>
      </div>
      <div class="col-4 col-md-3 text-right pr-xl-5 pr-lg-4 pr-md-3" [ngClass]="activeRefinance == 3 ? 'active' : ''">
        <p
          [ngClass]="{
            negativeValue: isPositive(term3TotalSavings) == -1,
            positiveValue: isPositive(term3TotalSavings) == 1
          }"
        >
          <strong>{{ term3TotalSavings | currency: 'USD':'symbol':'0.0-0' }}</strong>
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-3 form-label">Default Term</div>
      <div class="col-4 col-md-3 text-right pr-xl-5 pr-lg-4 pr-md-3" [ngClass]="activeRefinance == 1 ? 'active' : ''">
        <mat-slide-toggle
          color="primary"
          [checked]="activeRefinance == 1"
          [disabled]="activeRefinance == 1"
          (change)="activeRefinance = 1; updateMyHomeValuesInState()"
        >
        </mat-slide-toggle>
      </div>
      <div class="col-4 col-md-3 text-right pr-xl-5 pr-lg-4 pr-md-3" [ngClass]="activeRefinance == 2 ? 'active' : ''">
        <mat-slide-toggle
          color="primary"
          [checked]="activeRefinance == 2"
          [disabled]="activeRefinance == 2"
          (change)="activeRefinance = 2; updateMyHomeValuesInState()"
        >
        </mat-slide-toggle>
      </div>
      <div class="col-4 col-md-3 text-right pr-xl-5 pr-lg-4 pr-md-3" [ngClass]="activeRefinance == 3 ? 'active' : ''">
        <mat-slide-toggle
          color="primary"
          [checked]="activeRefinance == 3"
          [disabled]="activeRefinance == 3"
          (change)="activeRefinance = 3; updateMyHomeValuesInState()"
        >
        </mat-slide-toggle>
      </div>
    </div>
  </section>
  <div class="refinance-chart row mt-3 mx-0" *ngIf="isChartVisible">
    <div class="col-12">
      <app-bar-chart [barChartConfig]="barChartConfig"></app-bar-chart>
    </div>
  </div>
</div> -->
